import React from 'react';
import { Grid } from '@material-ui/core';

import TopViewAction from './actions/TopViewAction';
import BottomViewAction from './actions/BottomViewAction';
import SelectMediaDeviceAction from './actions/SelectMediaDeviceAction';
import RecordingList from './record/RecordingList';
import { StudioControlStyles } from '../styles';
import SyncTeleprompterAction from "./actions/SyncTeleprompterAction";
import StartDelayAction from "../actions/StartDelayAction";
import SelectAudioDeviceAction from "./actions/SelectAudioDeviceAction";

type Props = {
  bottomViewContainerId: string;
  videoDevices: MediaDeviceInfo[];
  audioDevices: MediaDeviceInfo[];
};

const CameraSettingsPanelDesktop = (
  { bottomViewContainerId, audioDevices, videoDevices }: Props,
) => {
  const classes = StudioControlStyles();

  return (
    <>
      <Grid
        item
        container
        style={{
          width: '100%',
          height: '100%',
          maxWidth: 'calc(100% - 340px)',
        }}
      >
        <Grid
          item
          style={{
            width: '100%',
            height: '100%',
            maxWidth: 180,
            paddingRight: 8,
          }}
        >

          <SelectMediaDeviceAction videoDevices={videoDevices}/>
          <SelectAudioDeviceAction audioDevices={audioDevices}/>
          <SyncTeleprompterAction />
          <StartDelayAction/>
        </Grid>
        <Grid
          item
          style={{
            maxWidth: 'calc(100% - 180px)',
            width: '100%',
            paddingLeft: 8,
          }}
        >
          <RecordingList />
        </Grid>
      </Grid>
      <Grid
        item
        container
        style={{
          width: 340,
          height: '100%',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TopViewAction />
          </Grid>
          <Grid item xs={6}>
            <BottomViewAction />
          </Grid>
        </Grid>
        <Grid
          container
          className={classes.studioBottomView}
          id={bottomViewContainerId}
        >
        </Grid>
      </Grid>
    </>
  );
};

export default CameraSettingsPanelDesktop;
